/**
 * Утилиты для работы с форматами баттлов
 */

/**
 * Получить иконку для формата баттла
 * @param {string} format - Формат баттла (AUDIO, TEXT)
 * @returns {string} Эмодзи-иконка
 */
export const getFormatIcon = (format) => {
    const icons = {
        AUDIO: '🎵',
        TEXT: '📝',
    };
    return icons[format] || '📌';
};

/**
 * Получить label для формата баттла
 * @param {string} format - Формат баттла
 * @returns {string} Человекочитаемое название
 */
export const getFormatLabel = (format) => {
    const labels = {
        AUDIO: 'Аудио',
        TEXT: 'Текст',
    };
    return labels[format] || format;
};

/**
 * Получить описание формата
 * @param {string} format - Формат баттла
 * @returns {string} Описание
 */
export const getFormatDescription = (format) => {
    const descriptions = {
        AUDIO: 'Аудио-баттлы: рэп, подкасты, вокал и другие аудио-форматы',
        TEXT: 'Текстовые баттлы: стихи, проза, эссе и другие текстовые форматы',
    };
    return descriptions[format] || 'Баттл';
};

/**
 * Получить допустимые типы файлов для формата
 * @param {string} format - Формат баттла
 * @returns {object} Объект с accept-атрибутом и описанием
 */
export const getFormatFileTypes = (format) => {
    const fileTypes = {
        AUDIO: {
            accept: 'audio/*',
            hint: 'Аудиофайлы: MP3, WAV, OGG, FLAC и другие',
            maxFileSize: 50 * 1024 * 1024, // 50 MB
        },
        TEXT: {
            accept: '.txt,.doc,.docx,.pdf,.rtf',
            hint: 'Текстовые файлы: TXT, DOC, DOCX, PDF, RTF',
            maxFileSize: 10 * 1024 * 1024, // 10 MB
        },
    };
    return fileTypes[format] || { accept: '*/*', hint: 'Любые файлы', maxFileSize: 30 * 1024 * 1024 };
};

/**
 * Получить цвет бейджа для формата
 * @param {string} format - Формат баттла
 * @returns {string} Bootstrap variant (info, warning, success, etc.)
 */
export const getFormatBadgeVariant = (format) => {
    const variants = {
        AUDIO: 'info',
        TEXT: 'warning',
    };
    return variants[format] || 'secondary';
};

/**
 * Опции форматов для селектов
 */
export const FORMAT_OPTIONS_WITH_ICONS = [
    { value: 'AUDIO', label: '🎵 Аудио' },
    { value: 'TEXT', label: '📝 Текст' },
];
